<template>
  <div
    v-if="screenMobile"
    id="screen-dom"
    :style="screenMobileHeight()"
    class="screen-mobile"
    @mouseenter="handleMouseActionIsIn(true)"
    @click="handleScreenClick"
    @mouseleave="handleMouseActionIsIn(false)"
  >
    <component
      :is="ProjectInfo.Background.componentName"
      :ProjectInfo="ProjectInfo"
      :Configuration="ProjectInfo.Background"
    >
    </component>

    <VShape
      v-for="item in ProjectInfo.CurrentScene.Charts"
      :key="item.id"
      :Configuration="item"
      :ProjectInfo="ProjectInfo"
      :active="$store.state.CurrentConfigration.id === item.id"
    >
      <component
        :is="item.propertyData.borderConfig.value.borderComponentName"
        :Configuration="item"
        :ProjectInfo="ProjectInfo"
      >
        <component
          :is="item.componentName"
          :Configuration="item"
          :ComboBoxId="item.id"
          :ComboBoxCharts="item.Charts"
          :ProjectInfo="ProjectInfo"
        ></component>
      </component>
    </VShape>

    <component
      :is="ProjectInfo.Style.componentName"
      :ProjectInfo="ProjectInfo"
      :Configuration="ProjectInfo.Style"
    >
    </component>
    <component
      :is="ProjectInfo.Style.componentName + 'Bottom'"
      :ProjectInfo="ProjectInfo"
      :SceneryList="ProjectInfo.SceneryList"
      :Configuration="ProjectInfo.Style"
    >
    </component>

    <minify-charts-container
      :currentCharts="ProjectInfo.CurrentScene.Charts"
      :position="'left'"
    ></minify-charts-container>
    <minify-charts-container
      :currentCharts="ProjectInfo.CurrentScene.Charts"
      :position="'right'"
    ></minify-charts-container>
  </div>
  <div
    v-else
    id="screen-dom"
    class="screen"
    @mouseenter="handleMouseActionIsIn(true)"
    @click="handleScreenClick"
    @mouseleave="handleMouseActionIsIn(false)"
  >
    <component
      :is="ProjectInfo.Background.componentName"
      :ProjectInfo="ProjectInfo"
      :Configuration="ProjectInfo.Background"
    >
    </component>

    <VShape
      v-for="item in ProjectInfo.CurrentScene.Charts"
      :key="item.id"
      :Configuration="item"
      :ProjectInfo="ProjectInfo"
      :active="$store.state.CurrentConfigration.id === item.id"
    >
      <component
        :is="item.propertyData.borderConfig.value.borderComponentName"
        :Configuration="item"
        :ProjectInfo="ProjectInfo"
      >
        <component
          :is="item.componentName"
          :Configuration="item"
          :ComboBoxId="item.id"
          :ComboBoxCharts="item.Charts"
          :ProjectInfo="ProjectInfo"
        ></component>
      </component>
    </VShape>

    <component
      :is="ProjectInfo.Style.componentName"
      :ProjectInfo="ProjectInfo"
      :Configuration="ProjectInfo.Style"
    >
    </component>
    <component
      :is="ProjectInfo.Style.componentName + 'Bottom'"
      :ProjectInfo="ProjectInfo"
      :SceneryList="ProjectInfo.SceneryList"
      :Configuration="ProjectInfo.Style"
    >
    </component>

    <minify-charts-container
      :currentCharts="ProjectInfo.CurrentScene.Charts"
      :position="'left'"
    ></minify-charts-container>
    <minify-charts-container
      :currentCharts="ProjectInfo.CurrentScene.Charts"
      :position="'right'"
    ></minify-charts-container>
  </div>
</template>

<script>
import MinifyChartsContainer from '../../components/screen/MinifyChartsContainer';
let _AutoImportComponengts = () => {
  const path = require('path');
  const _Componengts = {};
  const files = require.context('@/components/backgrounds', true, /\.vue$/);

  files.keys().forEach(key => {
    const name = path.basename(key, '.vue');

    _Componengts[name] = files(key).default || files(key);
  });
  const files2 = require.context('@/components/charts', true, /\.vue$/);
  files2.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files2(key).default || files2(key);
  });
  const files3 = require.context('@/components/styles', true, /\.vue$/);
  files3.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files3(key).default || files3(key);
  });
  const files4 = require.context('@/components/borders', true, /\.vue$/);
  files4.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files4(key).default || files4(key);
  });

  for (let key in _Componengts) {
    if (key.endsWith('Background')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _BackgroundsList.push(Configuration);
      }
    }
    if (key.endsWith('Style')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _StylesList.push(Configuration);
      }
    }
    if (key.endsWith('Charts')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _ChartsList.push(Configuration);
      }
    }
  }
  return _Componengts;
};
const _BackgroundsList = [];
const _StylesList = [];
const _ChartsList = [];
const _AutoComponengts = _AutoImportComponengts();
// console.log('初始化 组件导入：', _AutoComponengts);

import VShape from '@/views/commonviews/VShape.vue';

import { mapMutations, mapState } from 'vuex';
export default {
  name: 'Screen',
  props: {
    ProjectInfo: Object,
  },
  data() {
    return {
      screenMobile: false,
      projectInfoData: {},
    };
  },
  components: {
    MinifyChartsContainer,
    VShape,
    ..._AutoComponengts,
  },
  created() {
    this.set_BackgroundsList(_BackgroundsList);
    this.set_StylesList(_StylesList);
    this.set_ChartsList(_ChartsList);

    this.screenMobile = this.$store.state.isMobile;
    this.projectInfoData = this.$store.state.ProjectInfo;
    this.$store.commit('setBackgroundDefault', JSON.parse(JSON.stringify(this.ProjectInfo.Background)));
  },
  watch: {
    isMobile: {
      deep: true,
      handler: function(vn, vo) {
        if (vn) {
          this.screenMobile = vn;
        }
      },
    },
    ProjectInfo: {
      deep: true,
      handler: function(vn, vo) {
        if (vn) {
          this.projectInfoData = vn;
        }
      },
    },
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      ProjectInfo: state => state.ProjectInfo,
    }),
  },
  methods: {
    ...mapMutations([
      'set_BackgroundsList',
      'set_StylesList',
      'set_ChartsList',
      'set_isMouseEnteredScreen',
      'del_CurrentConfigration',
    ]),
    handleMouseActionIsIn(status) {
      this.set_isMouseEnteredScreen(status);
    },
    // 移动端 高度样式
    screenMobileHeight() {
      let screenHeight = document.body.clientHeight;
      return {
        // width: 100 + '%',
        height: screenHeight + 'px',
      };
    },
    handleScreenClick(e) {
      const infoID = this.getInfoIDFromEvent(e);
      e.stopPropagation();

      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
      this.del_CurrentConfigration();
    },
    getInfoIDFromEvent(event) {
      console.log(event);

      // return event.target.dataset.infoID;
    },
  },
};
</script>

<style lang="scss" scoped>
.screen {
  position: relative;
  user-select: none;
  overflow: hidden;
  width: 100%;
  height: 100%;
  color: $font-color-base;
}
.screen-mobile {
  overflow-x: hidden;
  overflow-y: auto;
  color: $font-color-base;
  position: relative;
  user-select: none;
}
.screen-mobile::-webkit-scrollbar {
  /* 修改滚动条宽度 */
  width: 4px;
}
.screen-mobile::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #afaeae;
}
</style>
